// Ensures Bootstrap 5 data API picks up dynamically loaded navbar toggler if Angular renders after DOMContentLoaded.
// Safe no-op if already initialized.
document.addEventListener('DOMContentLoaded', () => {
  try {
    const toggler = document.querySelector('.navbar-toggler[data-bs-toggle="collapse"]');
    if (toggler && globalThis.bootstrap?.Collapse) {
      const targetSel = toggler.getAttribute('data-bs-target');
      if (targetSel) {
        const targetEl = document.querySelector(targetSel);
        if (targetEl && !targetEl.classList.contains('collapse')) {
          targetEl.classList.add('collapse');
        }
      }
    }
  } catch (error) {
    console.error('Bootstrap navbar initialization failed.', error);
  }
});